import React, { Component } from 'react';
import './footer.css';
import { Link } from "react-router-dom";



export default class Footer extends Component {
  render() {

    const year = new Date().getFullYear();
    return (
      <React.Fragment>
      <div className="main-footer">
        <div className="container">
        
          <img className="logo" alt="Brasão Sabugueiro" src='/images/logo-white.png' />
          
          <div className="social-media-div">
            <a href={this.setWebsiteUrl("www.instagram.com/serradaestrela")} target="_blank" rel="noopener noreferrer">
              <img className="social-media-icon" src='/images/instagram.png' alt=""></img>
            </a>
            <a href={this.setWebsiteUrl("www.facebook.com/freguesiade.sabugueiro")} target="_blank" rel="noopener noreferrer">
              <img className="social-media-icon" src='/images/facebook.png' alt=""></img>
            </a>
          </div>
        </div>
      </div>
      <div className="second-footer">

        <div className="container ">
          <div className="row">
            <div className="col-12 col-md-3 parent">
              <Link to="/noticias_e_eventos"><p>Notícias e Eventos</p></Link>
              <Link to="/alojamentos"><p>Alojamento</p></Link>
              <Link to="/restaurantes"><p>Restaurantes</p></Link>
              <Link to="/lojas"><p>Lojas</p></Link>
              <Link to="/contactos"><p>Contactos</p></Link>
              <Link to="/termos_e_condicoes"><p>Termos e Condições</p></Link>
              
            </div>
            <div className="col-12 col-md-3 useful-links">
              <a target="_blank" href="https://www.absabugueiro.com" rel="noopener noreferrer">Associação de Beneficiência do Sabugueiro</a>
              <a target="_blank" href="https://www.cm-seia.pt" rel="noopener noreferrer">Câmara de Seia</a>
            </div>
            <div className="col-12 col-md-6 instagram-feed">
              <p>#sabugueiro</p>
              <div>
                <img src="/images/instagram/instagram1.jpg" alt=""></img>
                <img src="/images/instagram/instagram2.jpg" alt=""></img>
                <img src="/images/instagram/instagram3.jpg" alt=""></img>
                <img src="/images/instagram/instagram4.jpg" alt=""></img>
                <img src="/images/instagram/instagram5.jpg" alt=""></img>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="third-footer">
        <div className="container">
          <div className="row align-flex">

          <div className="col-12 col-md-6">
            <p className="copyright-footer">Copyright Ⓒ {year} Freguesia do Sabugueiro - Todos os direitos reservados</p>
          </div>
          <div className="col-12 col-md-6">
            <p className="copyright-footer second-paragraph">Desenvolvido por: André Maximino / Paulo Cruz</p>
          </div>
          </div>
          
        </div>
      </div>
      </React.Fragment>
    )
  }

  setWebsiteUrl = (url) => {
    return "https://" + url;
  }
}
